import { render } from "./ComHeader.vue?vue&type=template&id=264bc8e4&scoped=true"
import script from "./ComHeader.vue?vue&type=script&lang=js"
export * from "./ComHeader.vue?vue&type=script&lang=js"

import "./ComHeader.vue?vue&type=style&index=0&id=264bc8e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-264bc8e4"]])

export default __exports__